exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".animated_toolbar_button__disabled--2LX5h {\n\topacity: .5;\n}\n", ""]);

// exports
exports.locals = {
	"disabled": "animated_toolbar_button__disabled--2LX5h"
};